import React, { useState, useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { LoadScript } from "@react-google-maps/api";
import { useParams } from "react-router-dom";
// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/CustomButton.js";
import VehicleIcon from "components/CustomIcons/Vehicle.js";
import MotorhomeIcon from "components/CustomIcons/Motorhome.js";
import MotorcycleIcon from "components/CustomIcons/Motorcycle";
import ATVIcon from "components/CustomIcons/ATV";
import WhiteCalendarIcon from "components/CustomIcons/WhiteCalendar";
import WhiteCarIcon from "components/CustomIcons/WhiteCar";
import WhiteCheckIcon from "components/CustomIcons/WhiteCheck";

import { makeStyles } from "@material-ui/core/styles";
import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import stylePrincipal from "assets/jss/material-dashboard-pro-react/components/principalStyle.js";
import stylesAlerts from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";

import Step1 from "./CancellationSteps/Step1.js";
import PaymentType from "components/PaymentType/PaymentType.js";
import CreditCardList from "components/CreditCard/CreditCardList.js";
import SweetAlert from "react-bootstrap-sweetalert";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import Close from "@material-ui/icons/Close";

import extendedFormstyles from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import formStyles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { RotatingLines } from "react-loader-spinner";
import stylesDialogs from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.js";
import { getTokenClient } from "components/Utils/applePay.js";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { checkIfIsKiosko, isAgent } from "components/Utils/utils";

//Componentes
import StepperComponent from "components/Stepper/StepperComponent";
import DeleteCreditCard from "components/DeleteCreditCard/DeleteCreditCard.js";
import CustomModal from "components/CustomModal/Modal.js";
import CustomButton from "components/CustomButtons/CustomButton";

import "../../assets/css/freewayStyle.css";
import "../../assets/css/successModal.css";

import {
  formatCreditCardNumber,
  formatExpirationDate,
  setDataPolicy,
  formatNumber,
  addDays,
  sanatizeMessageHtml,
  formatDateToEffectiveAndExpiration,
  setDataFromGuest,
  currentDateEffective,
  checkValueLanguage,
  setDataCancellation,
} from "components/Utils/utils.js";

import { Catalogs } from "views/Services/CatalogsService.js";
import { getVehiclesList } from "views/Services/VehiclesService.js";
import {
  getAgencyData,
  getAgencyIdByCode,
} from "views/Services/AgencyService.js";
import { saveCancellation } from "views/Services/CancellationService.js";

import {
  issue,
  checkQuote,
  getAppleTokenClient,
  getCustomerByToken,
  print,
} from "views/Services/OrdersService";

import {
  addCard,
  getCardsByClient,
  deleteCard,
} from "../Services/CreditCardService.js";
import { useTranslation } from "react-i18next";
import { getPolicyData } from "views/Services/PoliciesService";
import { getUTCDate } from "components/Utils/utils.js";
import { use } from "react";
import { current } from "@reduxjs/toolkit";
import { update } from "@react-spring/web";

const monthList = {
  January: "01",
  February: "02",
  March: "03",
  April: "04",
  May: "05",
  June: "06",
  July: "07",
  August: "08",
  September: "09",
  October: "10",
  November: "11",
  December: "12",
};

const timeZoneList = {
  1: 12,
  2: 8,
  3: 17,
  4: 33,
  5: 12,
  6: 33,
};

const currentDateEndorsement = new Date().toISOString().split("T")[0];
const currentTimeEndorsement = new Date().toTimeString().split(" ")[0];

const useStyles = makeStyles(styles);
const useStylesDialog = makeStyles(stylesDialogs);

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const WizardView = React.forwardRef((props) => {
  const { t, i18n } = useTranslation();
  const routeParams = useParams();
  const { id, producerCode } = routeParams;
  const { getAgencyType } = props;
  const childRefStep1 = useRef(null);
  const childRefStep2 = useRef(null);
  const childRefStep3 = useRef(null);
  const childRefStep4 = useRef(null);

  const isKiosko = checkIfIsKiosko();

  const isLogged = localStorage.getItem("userToken") !== null ? true : false;

  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only("xs"));
  const isSm = useMediaQuery(theme.breakpoints.only("sm"));
  useEffect(() => {
    setSteps([
      { title: t("steps.quote") },
      { title: t("steps.insuredInformation") },
      { title: t("steps.vehicleInformation") },
      { title: t("steps.coverageAndPayment") },
    ]);
  }, [i18n.language]); // Observamos solo el idioma

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);

  const getVehicleType = urlParams.get("ChooseVehicle");
  const getDays = urlParams.get("txtDays");
  const getValue = urlParams.get("txtValue");
  const getStartDate = urlParams.get("startDate");
  const [resultRates, setResultRates] = useState({
    policy_fee: "15",
    csl_rate: 7.8,
    premium: 89,
    total: 104,
    iva: 0,
    value: 7000,
    pd_ded: 500,
    theft_ded: 1000,
    additional_charges: false,
    total1: 104,
    days1: "6",
    total2: 332,
    days2: 182,
    total3: 468,
    days3: 365,
    total4: 302,
    days4: 90,
    debug: false,
    agency: "81001",
    agency_fee: "0",
  });

  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const [agencyData, setAgencyData] = useState(null);
  const [fastQuote, setFastQuote] = useState(true);
  const [fullQuoteVehicle, setFullQuoteVehicle] = useState(false);
  const [isOpenErrors, setIsOpenErrors] = useState(false);
  const [disabledPayButton, setDisabledPayButton] = useState(false);
  const [modalTerms, setModalTerms] = useState(false);
  const [fullQuoteRates, setFullQuoteRates] = useState(false);
  const [calculateRates, setCalculateRates] = useState(false);
  const [addVehicle, setAddVehicle] = useState(false);
  const [showAddVehicle, setShowAddVehicle] = useState(false);
  const [saveCard, setSaveCard] = useState(false);
  const [vehicleDataFromSite, setVehicleDataFromSite] = useState(false);
  const [paymentType, setPaymentType] = React.useState(2);
  const [paymentTypeList, setPaymentTypeList] = React.useState([{}]);
  const [editCardData, setEditCardData] = React.useState({});
  const [paymentModal, setPaymentModal] = React.useState(false);
  const [isAppleDevice, setIsAppleDevice] = useState(false);
  const [tokenApple, setTokenApple] = useState("");
  const [savingCard, setSavingCard] = useState(false);
  const [creditCardListModal, setCreditCardListModal] = useState(false);
  const [vinPolicy, setVinPolicy] = useState(false);
  const [checkedAccount, setCheckedAccount] = useState(false);
  const [orderDataSuccess, setOrderDataSuccess] = useState({});
  const [modalSuccess, setModalSuccess] = useState(false);
  const [policyDataLogin, setPolicyDataLogin] = useState({});
  const [vehicles, setVehicles] = useState([]);
  const [currentStartDate, setCurrentStartDate] = useState("");
  const now = new Date();
  const utcNow = new Date(
    Date.UTC(
      now.getFullYear(),
      now.getMonth(),
      now.getDate(),
      now.getHours(),
      now.getMinutes(),
      now.getSeconds()
    )
  );
  const [vehicleData, setVehicleData] = useState({
    vehtype: "1",
    vehicle_type_id: "1",
    year_vehicle: 2025,
    vehicleYear: 2025,
    agent: "",
    hasLienholder: "no",
    fullCoverage: "yes",
    towingUnits: "no",
    model_vehicle: "",
    make_vehicle: "",
    makeVehicle: "",
    type_name: "",
    vehicle_type: null,
    id: "",
    lienholder: "",
    insurance_company: "",
    insurance_policy_number: "none",
    mileage: "",
    plates: "",
    sp_equip_list: null,
    sp_equip_value: null,
    total_value: "",
    trailer: "",
    vin: "",
    year_model: "",
    client_id: "",
    model: " ",
    vehicle_type_id: "",
    sentri_number: "",
    other: "",
    year_model_trailer: "",
    model_trailer: "",
    vin_trailer: "",
    total_value_trailer: -1,
    startDate: utcNow.toISOString().split("T")[0],
    plates_trailer: "",
    lienholder_trailer: null,
    sp_equip_list_trailer: null,
    sp_equip_value_trailer: null,
    year_model_other: "",
    model_other: "",
    vin_other: "",
    total_value_other: "",
    plates_other: "",
    lienholder_other: null,
    sp_equip_list_other: null,
    sp_equip_value_other: null,
    make_trailer: "",
    make_other: "",
    make: "",
    lienholder_vehicle_address: "",
    lienholder_trailer_address: null,
    lienholder_other_address: null,
    vehtype_trailer: "",
    vehtype_other: "",
    description_trailer: "",
    description_other: "",
    other_policy_company_trailer: "",
    other_policy_number_trailer: "",
    other_policy_company_other: "",
    other_policy_number_other: "",
    commercial: "",
    client_have_lienholder: "",
    vehicle_type_model: "",
    makeId: "",
    name: "",
    modelId: "",
  });
  const [personData, setPersonData] = useState({
    id: "New Client",
    vehtype: 1,
    agent: "",
  });

  const [coverages, setCoverages] = useState({
    days: 0,
    csllimit: "500000",
    excessliab: "150000",
    country: 0,
    policy_type: 1,
    medicallimit: "5000",
    damageded: 2,
    theftded: 5,
    vehtype: "1",
    vehicle_type_id: "1",
    year_vehicle: 2025,
    vehicleYear: 2025,
    startDate: utcNow.toISOString().split("T")[0],
    specialdiscount: 1,
    effectivedate: "",
    expirationdate: "",
    bordercross: 2,
    gapcoverage: "no",
    premierepackage: true,
    fixeddeductible: true,
    policycaravan: false,
    roadside: true,
    physical_damage: true,
    theft: true,
    legalaid: true,
    hdiautoguard: false,
    accessories_and_safety: false,
    ter_ext: false,
    csrinitials: "",
  });

  const setAlertAgencyData = async (agencyId) => {
    const resultSubmit = await dispatch(getAgencyData(`?id=${agencyId}`));
    setAgencyData(resultSubmit.payload.data);
    getAgencyType(resultSubmit.payload.data.agency_type_name);
    setUrlParams(agencyId, resultSubmit.payload.data.default_border_crossing);
    return resultSubmit.payload.data;
  };

  const getDataVinVehicle = (vehicleData) => {
    childRefStep3.current.getDataVinVehicle(vehicleData);
  };

  const checkValidateDate = (coverages, vehicleData) => {
    childRefStep4.current.checkValidateDate(coverages, vehicleData);
  };

  const getAgencyId = async (agencyCode) => {
    const resultSubmit = await dispatch(
      getAgencyIdByCode(`?agencyCode=${agencyCode}`)
    );
    if (typeof resultSubmit.payload.data.id != "undefined") {
      return setAlertAgencyData(resultSubmit.payload.data.id);
    } else {
      window.location = "/auth/login";
    }
  };

  React.useEffect(() => {
    if (!isAgent) {
      window.location.href = "/admin/home";
    }
    addPayment(false);
    if (window.ApplePaySession) {
      setIsAppleDevice(true);
      var merchantIdentifier = "merchant.sanborns.applepay";
      var promise = ApplePaySession.canMakePaymentsWithActiveCard(
        merchantIdentifier
      );
      promise.then(function () {
        getAppleClientToken();
        addPayment(true);
      });
    }

    getCustomer();

    if (Number(id) !== true) {
      getCatalogs();
    }
  }, [dispatch]);

  useEffect(() => {
    console.log("coverages updated", coverages);
  }, [coverages]);

  const classes = useStyles();
  const classesDialogs = useStylesDialog();
  const cardDataInitial = {
    "cnumber-card_string": "",
    "fname-card": "",
    "lname-card": "",
    "month-card": "",
    creditcardverificator_string: "",
    "year-card": "",
    expirationCard: "",
    focused: "",
    "id-card": "none",
  };
  const [card, setCard] = React.useState(cardDataInitial);
  const [showWizard, setshowWizard] = React.useState(true);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const [clientCards, setClientCards] = React.useState([]);
  const [selectedValue, setSelectedValue] = React.useState(null);
  const [alert, setAlert] = React.useState(null);
  const [alertLoading, setAlertLoading] = React.useState(null);
  const [alertAgency, setAlertAgency] = React.useState(false);
  const [openModalError, setOpenModalError] = React.useState(false);
  const [toastMessage, setToastMessage] = useState(false);
  const [showContinueGuest, setShowContinueGuest] = useState(false);
  const [messageToast, setMessageToast] = useState("");
  const [typeToast, setTypeToast] = useState("");
  const [checked, setChecked] = React.useState([]);
  const [deleteCardModal, setDeleteCardModal] = React.useState(false);
  const [idCardToDelete, setIdCardToDelete] = React.useState(null);
  const [loadingCircle, setLoadingCircle] = React.useState(false);
  const [typeExistUser, setTypeExistUser] = React.useState(false);

  const sendToLogin = () => {
    let loginData =
      typeExistUser == "both_found" || typeExistUser == "license_found"
        ? personData.dl_number
        : personData.email;
    localStorage.setItem("login", loginData);
    localStorage.setItem("dataPolicy", JSON.stringify(policyDataLogin));
    window.location.href = "/auth/login-customer";
  };

  const addPayment = () => {
    let paymentList = [
      { value: 2, label: "Credit Card" },
      { value: 5, label: "PayPal" },
    ];
    if (isAgent) {
      paymentList = [
        { value: 1, label: "Cash" },
        { value: 2, label: "Credit Card" },
        { value: 5, label: "PayPal" },
        { value: 4, label: "Agent will Charge" },
      ];
    }
    setPaymentTypeList(paymentList);
  };

  const getAppleClientToken = async () => {
    const resultSubmit = await dispatch(getAppleTokenClient({}));
    const token = resultSubmit.payload;
    setTokenApple(token);
  };

  const setCardData = (cards, cardId) => {
    let cardData = {};
    cards.forEach((element) => {
      if (element.id == cardId) {
        cardData["id-card"] = element.id;
        cardData["fname-card"] = element.first_name;
        cardData["lname-card"] = element.last_name;
        cardData["cnumber-card_string"] = element.number;
        cardData["type-ccard"] = element.card_type;
        let monthExpDate =
          typeof monthList[element.expiration_month] == "undefined"
            ? ""
            : monthList[element.expiration_month];
        cardData[
          "expirationCard"
        ] = `${monthExpDate}/${element.expiration_year}`;
        cardData["month-card"] = monthList[element.expiration_month];
        cardData["year-card"] = element.expiration_year;
        cardData["street-card"] = element.street;
        cardData["co-card"] = element.co;
        cardData["city-card"] = element.last_name;
        cardData["state-card"] = element.state;
        cardData["code-card"] = element.zipcode;
      }
    });
    return cardData;
  };

  const verifyPaymentType = () => {
    const paymentTypeValue = parseInt(paymentType);
    switch (paymentTypeValue) {
      case 2:
        handlerSaveCard();
        break;
      case 6:
        onApplePayButtonClicked();
        break;
      default:
        issuePolicy();
        break;
    }
  };

  const handleChangeRadio = (value) => {
    let dataPolicy = { ...data };
    let cardData = setCardData(clientCards, value);
    dataPolicy.card = cardData;
    setSelectedValue(value);
    setCard(cardData);
    setCreditCardListModal(false);
    setData(dataPolicy);
  };

  const toggleCardListModal = () => {
    setCreditCardListModal((prevState) => !prevState);
  };

  const toggleDeleteCardModal = () => {
    setDeleteCardModal((prevState) => !prevState);
  };

  const closeModal = () => {
    setMessageToast("");
    setPaymentModal(false);
  };

  const successPolicy = () => {
    window.location.href = `/guest/summary/${orderDataSuccess.order_id}`;
  };

  const callBackCard = () => {};

  const checkLoginButton = () => {
    return messageToast.includes("already linked to an account") &&
      localStorage.getItem("userToken") === null
      ? true
      : false;
  };

  const handlerCardData = (cardId) => {
    if (typeof cardId != "undefined") {
      let cardData = setCardData(clientCards, cardId);
      setCard(cardData);
      toggleCardListModal(false);
      setSavingCard(true);
      setSelectedValue(null);
    }
  };

  const inputHandler = ({ target }) => {
    let cardData = { ...card };
    let dataPolicy = { ...data };
    if (target.id === "cnumber-card_string") {
      let formatCreditCard = formatCreditCardNumber(target.value);
      target.value = formatCreditCard.value;
      cardData["type-ccard"] = formatCreditCard.cardTypeId;
    }
    if (target.id === "expirationCard") {
      target.value = formatExpirationDate(target.value);
      let value = target.value.split("/");
      cardData["month-card"] = value[0] ?? "";
      cardData["year-card"] = value[1] ?? "";
    }
    cardData[target.id] = target.value;
    dataPolicy.card = cardData;
    setData(dataPolicy);
    setCard(cardData);
  };

  const inputHandlerCcv = ({ target }) => {
    let cardData = { ...card };
    let dataPolicy = { ...data };
    cardData["creditcardverificator_string"] = target.value;
    dataPolicy.card = cardData;
    setData(dataPolicy);
    setCard(cardData);
  };

  const loadingAlert = () => {
    setAlertLoading(
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title={<h5 style={{ color: "black" }}>{"Loading"}</h5>}
        allowEscape={false}
        closeOnClickOutside={false}
        showConfirm={false}
        showCancel={false}
      >
        <RotatingLines
          strokeColor="gray"
          strokeWidth="5"
          animationDuration="0.75"
          width="96"
          visible={true}
        />
      </SweetAlert>
    );
  };

  const showAlertCard = (cardId) => {
    setIdCardToDelete(cardId);
    setDeleteCardModal(true);
  };

  const handlerSaveCard = (toSave) => {
    if (selectedValue == null) {
      let cardDataSave = { ...card };
      setSelectedValue(null);
      setSaveCard(true);
      let validCard = checkDataCard(cardDataSave);
      if (validCard) {
        toSave ? sendCardToSave(cardDataSave) : issuePolicy();
      }
    } else {
      issuePolicy();
    }
  };

  const cancelSaveCard = () => {
    setSelectedValue(null);
    setSavingCard(false);
    setCard(cardDataInitial);
  };

  const sendCardToSave = async (cardDataSave) => {
    let monthList = {
      1: "January",
      2: "February",
      3: "March",
      4: "April",
      5: "May",
      6: "June",
      7: "July",
      8: "August",
      9: "September",
      10: "October",
      11: "November",
      12: "December",
    };
    let cardData = {
      "client-id-card": data?.data_customer.id,
      "id-card": cardDataSave["id-card"],
      "fname-card": cardDataSave["fname-card"],
      "lname-card": cardDataSave["lname-card"],
      "cnumber-card": cardDataSave["cnumber-card_string"].replaceAll(" ", ""),
      "type-ccard": cardDataSave["type-ccard"],
      "month-card": monthList[parseInt(cardDataSave["month-card"])],
      "year-card": "20" + cardDataSave["year-card"],
      "street-card": cardDataSave["street-card"],
      "co-card": cardDataSave["co-card"],
      "city-card": cardDataSave["city-card"],
      "state-card": cardDataSave["state-card"],
      "code-card": cardDataSave["code-card"],
    };
    const resultSubmit = await dispatch(addCard(cardData));

    if (resultSubmit.payload.result) {
      getClientCards(data.data_customer.id);
      if (cardData["id-card"] > 0) {
        setCard(cardDataInitial);
      }
      setIsModalOpen(false);
      setEditCardData(false);
      setSavingCard(false);
      setSaveCard(false);
    } else {
      let mensaje = "\n";
      for (const key in resultSubmit.payload.message) {
        mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
      }
    }
  };

  const checkDataCard = (cardDataSave) => {
    let valid = true;
    cardDataSave["month-card"] =
      typeof cardDataSave["month-card"] == "undefined"
        ? ""
        : parseInt(cardDataSave["month-card"]);
    if (
      cardDataSave["cnumber-card_string"].replaceAll(" ", "") < 16 ||
      cardDataSave["cnumber-card_string"] == "" ||
      cardDataSave["cnumber-card_string"] == null ||
      typeof cardDataSave["month-card"] == "undefined" ||
      cardDataSave["month-card"] == null ||
      cardDataSave["fname-card"] == "" ||
      cardDataSave["fname-card"] == null ||
      typeof cardDataSave["fname-card"] == "undefined" ||
      cardDataSave["lname-card"] == "" ||
      cardDataSave["lname-card"] == null ||
      typeof cardDataSave["lname-card"] == "undefined" ||
      cardDataSave["type-ccard"] == "" ||
      cardDataSave["type-ccard"] == null ||
      typeof cardDataSave["type-ccard"] == "undefined" ||
      cardDataSave["month-card"] == "" ||
      cardDataSave["month-card"] == null ||
      cardDataSave["month-card"] > 12 ||
      cardDataSave["month-card"] == 0 ||
      cardDataSave["year-card"] == "" ||
      cardDataSave["year-card"] == null ||
      typeof cardDataSave["year-card"] == "undefined"
    ) {
      let messageToast = "";
      messageToast +=
        cardDataSave["month-card"] > 12 ||
        cardDataSave["month-card"] == 0 ||
        cardDataSave["month-card"] == ""
          ? "Please enter a valid month expiration date"
          : "";
      messageToast +=
        cardDataSave["year-card"] == ""
          ? "Please enter a valid year expiration date"
          : "";
      messageToast =
        messageToast == ""
          ? "Please check the information in your credit card"
          : messageToast;
      setMessageToast(messageToast);
      valid = false;
    }
    return valid;
  };

  const onApplePayButtonClicked = async () => {
    tokenClient = getTokenClient(data, issuePolicy, tokenApple);
  };

  const processResponseIssue = (resultSubmit) => {
    if (resultSubmit.payload) {
      if (resultSubmit.payload.message.errors) {
        let messageToast = "";
        resultSubmit.payload.message.errors.map(
          (error) =>
            (messageToast += `${error.Message}<br>
            `)
        );
        setMessageToast(messageToast);
        let dataPolicy = setDataFromGuest({ ...data });
        setPolicyDataLogin(dataPolicy);
      } else {
        if (typeof resultSubmit.payload.approvalUrl != "undefined") {
          window.location.href = resultSubmit.payload.approvalUrl;
        } else {
          window.dataLayer.push({
            event: "gtm.formSubmit",
            hostname: window.location.origin,
            customer:
              localStorage.getItem("userToken") !== null ? "existing" : "new",
            eventLabel: "Sale",
            raterVersion: "Quote",
          });
          setPaymentModal(false);
          setOrderDataSuccess(resultSubmit.payload);
          setModalSuccess(true);
        }
      }
    } else {
      let mensaje = "\n";
      for (const key in resultSubmit.payload.message) {
        mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
      }
    }
  };

  const issuePolicy = async (appleData) => {
    if (paymentValid) {
      setToastMessage(false);
      let dataQuote = { ...data };
      dataQuote.paymentType = paymentType;
      let dataPolicy = setDataPolicy(dataQuote);
      dataPolicy.view =
        localStorage.getItem("userToken") !== null ? "" : "guest";
      if (typeof appleData != "undefined") {
        dataPolicy.nonce = appleData.nonce;
        dataPolicy.deviceData = appleData.deviceData;
      }
      if (isKiosko) {
        dataPolicy.kiosko = true;
        if (localStorage.getItem("userToken") !== null) {
          const agencyFilter = data.catalogs.agencies.filter(
            (agency) =>
              agency.producer_code === localStorage.getItem("producerCode")
          );
          dataPolicy.agency = agencyFilter[0].id;
        }
      }
      setLoadingCircle(true);
      dataPolicy.newRate = true;
      dataPolicy.preferred_language =
        localStorage.getItem("userType") === "3"
          ? i18n.language
          : dataPolicy.preferred_language;
      dataPolicy.preferred_language =
        typeof dataPolicy.preferred_language !== "undefined"
          ? checkValueLanguage(dataPolicy.preferred_language)
          : "en";
      dataPolicy.userType = localStorage.getItem("userType");
      const resultSubmit = await dispatch(issue(dataPolicy));
      setLoadingCircle(false);
      setDisabledPayButton(false);
      processResponseIssue(resultSubmit);
    } else {
      let errorMessageIssue = "";
      if (validCard) {
        errorMessageIssue += !ccvValid
          ? "<li>Please enter a ccv valid</li>"
          : "";
        setMessageToast(errorMessageIssue);
        setOpenModalError(true);
      }
      setDisabledPayButton(false);
    }
  };

  const checkInfoQuote = async (dataPolicy) => {
    loadingAlert();
    const resultSubmit = await dispatch(checkQuote(dataPolicy));
    setAlertLoading(null);
    if (resultSubmit.payload) {
      if (!resultSubmit.payload.result) {
        let messageToast = ``;
        let errorCount = resultSubmit.payload.message.errors.length;
        resultSubmit.payload.message.errors.map((error) => {
          messageToast += `${error.Message}<br>`;
        });
        dataPolicy = setDataFromGuest({ ...data });
        const continueEmailDriver = showButtonContinue(
          messageToast,
          errorCount
        );
        if (continueEmailDriver) {
          continueToPayment();
        } else {
          setPolicyDataLogin(dataPolicy);
          setMessageToast(messageToast);
          setIsOpenErrors(true);
        }
      } else {
        continueToPayment();
      }
    } else {
      let mensaje = "\n";
      for (const key in resultSubmit.payload.message) {
        mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
      }
    }
  };

  const continueToPayment = () => {
    setMessageToast("");
    setPaymentModal(true);
    setActiveStep(3);
  };

  const showButtonContinue = (messageError, countErrors) => {
    const driverError = messageError.includes(
      "Drivers License is already linked to an account"
    );
    const emailError = messageError.includes(
      "Email is already linked to an account"
    );
    const typeUserExists =
      driverError && emailError
        ? "both_found"
        : driverError
        ? "license_found"
        : "email_found";
    setTypeExistUser(typeUserExists);
    const continueGuest = checkIfContinueGuest(
      driverError,
      emailError,
      countErrors
    );
    setShowContinueGuest(continueGuest);
    return continueGuest;
  };

  const checkIfContinueGuest = (driverError, emailError, countErrors) => {
    return (
      (driverError && countErrors == 1) ||
      (emailError &&
        countErrors == 1 &&
        localStorage.getItem("userToken") === null) ||
      (driverError && emailError && countErrors == 2) ||
      checkedAccount
    );
  };

  const getCatalogs = async () => {
    const resultSubmit = await dispatch(Catalogs());
    if (resultSubmit.payload.result) {
      let dataPolicy = {
        data_customer: {
          id: "New Client",
          dl_number: "",
          dl_country_id: 0,
          valid_license: "",
          dl_state_id: 0,
          first_name: "",
          middle_name: "",
          last_name: "",
          address: "",
          zipcode: "",
          city: "",
          country_id: 0,
          state_id: 0,
          phone: "",
          email: "",
          additional_insured: "",
          agency_id: "",
        },
        coverages: {},
        selectedVehicle: {},
      };
      dataPolicy["catalogs"] = resultSubmit.payload.catalogs;
      if (dataPolicy["catalogs"].vehicle_types) {
        let vehicle = dataPolicy["catalogs"].vehicle_types.find(
          (item) => item.id === "1"
        );
        vehicle &&
          (vehicle.icon = <VehicleIcon className={classes.optionInput} />);
        vehicle = dataPolicy["catalogs"].vehicle_types.find(
          (item) => item.id === "4"
        );
        vehicle &&
          (vehicle.icon = <MotorhomeIcon className={classes.optionInput} />);
        vehicle = dataPolicy["catalogs"].vehicle_types.find(
          (item) => item.id === "5"
        );
        vehicle &&
          (vehicle.icon = <MotorcycleIcon className={classes.optionInput} />);

        vehicle = dataPolicy["catalogs"].vehicle_types.find(
          (item) => item.id === "11"
        );
        vehicle && (vehicle.icon = <ATVIcon className={classes.optionInput} />);
        //vehicle = dataPolicy["catalogs"].vehicle_types.find(item => item.id === "10");
        //vehicle && (vehicle.icon = <TruckIcon className={classes.optionInput} />);
        dataPolicy["catalogs"].vehicle_types.splice(6, 1);
        dataPolicy["catalogs"].vehicle_types.splice(4, 1);
        dataPolicy["catalogs"].vehicle_types.splice(3, 1);
      }
      let producerCodeOnline = "";
      const agencyDataOnline = dataPolicy["catalogs"].agencies.find(
        (item) => item.agency_name === "Sanborn's - Online"
      );
      const userToken = localStorage.getItem("userToken");
      if (userToken === null) {
        producerCodeOnline =
          typeof agencyDataOnline !== "undefined"
            ? agencyDataOnline.producer_code
            : "";
        if (isKiosko) {
          producerCodeOnline = id;
        }
      }
      dataPolicy.coverages = coverages;
      let agencyCode = parseInt(producerCode, 10);
      let dataAgency = [];
      if (isNaN(agencyCode)) {
        agencyCode = producerCodeOnline;
      }
      const isValidCode =
        !isNaN(Number(agencyCode)) || producerCode === "00000";
      if (isValidCode && userToken === null) {
        const codeToUse = producerCode === "00000" ? producerCode : agencyCode;
        dataAgency = await getAgencyId(codeToUse);
      } else {
        dataAgency =
          localStorage.getItem("userType") === "3"
            ? setUrlParams(0, 0)
            : await getAgencyId(localStorage.getItem("producerCode"));
      }
      if (isAgent) {
        dataPolicy.catalogs.special_discounts = dataAgency.specialDiscounts;
      }
      setData(dataPolicy);
    } else {
      let mensaje = "\n";
      for (const key in resultSubmit.payload.message) {
        mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
      }
    }
  };

  const setUrlParams = (agentId, defaultBorderCross) => {
    let currentVehicleData = { ...vehicleData };
    let currentCoveragesData = { ...coverages };
    let currentPersonData = { ...personData };
    if (getVehicleType != null) {
      const currentDate = currentDateEffective();
      currentCoveragesData.days = getDays;
      currentPersonData.days = getDays;
      currentVehicleData.days = getDays;
      currentCoveragesData.vehtype = getVehicleType;
      currentPersonData.vehtype = getVehicleType;
      currentVehicleData.vehtype = getVehicleType;
      const currentDateTime = new Date(currentDate);
      const startDateTime = new Date(getStartDate);
      const getStartDateFromSite =
        startDateTime < currentDateTime ? currentDate : getStartDate;
      let getFormatEffectiveDate = formatDateToEffectiveAndExpiration(
        getStartDateFromSite
      );
      let effectiveData = addDays(getDays, "effectivedate", {
        effectivedate: getFormatEffectiveDate.date,
      });
      currentCoveragesData.effectivedate = getFormatEffectiveDate.date;
      currentCoveragesData.startDate = getFormatEffectiveDate.dateComponent;
      currentCoveragesData.expirationdate = effectiveData.expirationDate.date;
      currentPersonData.startDate = getFormatEffectiveDate.dateComponent;
      currentVehicleData.startDate = getFormatEffectiveDate.dateComponent;
      currentPersonData.total_value_vehicle = getValue;
      currentVehicleData.total_value_vehicle = getValue;
      currentCoveragesData.total_value_vehicle = getValue;
      currentPersonData.total_value = getValue;
      currentVehicleData.total_value = getValue;
      currentCoveragesData.total_value = getValue;
      setPersonData(currentPersonData);
    }
    if (agentId > 0) {
      currentVehicleData.agent = agentId;
    }
    if (defaultBorderCross > 0) {
      currentVehicleData.borderCrossing = defaultBorderCross;
      currentCoveragesData.timezone = timeZoneList[defaultBorderCross];
    }
    if (isAgent) {
      currentCoveragesData.days = 3;
      currentPersonData.days = 3;
      currentVehicleData.days = 3;
      const splitDate = currentCoveragesData.startDate.split("-");
      const currentEffectiveDate = `${splitDate[1]}/${splitDate[2]}/${splitDate[0]}`;
      let getFormatEffectiveDate = formatDateToEffectiveAndExpiration(
        currentEffectiveDate
      );
      let effectiveData = addDays(3, "effectivedate", {
        effectivedate: getFormatEffectiveDate.date,
      });
      currentCoveragesData.effectivedate = getFormatEffectiveDate.date;
      currentCoveragesData.expirationdate = effectiveData.expirationDate.date;
      let getFormatExpirationDate = formatDateToEffectiveAndExpiration(
        effectiveData.expirationDate.date
      );
      currentCoveragesData.endDate = getFormatExpirationDate.dateComponent;
      currentVehicleData.total_value_trailer = "";
    }
    setCoverages(currentCoveragesData);
    setVehicleData(currentVehicleData);
  };

  const getCustomer = async (customerId) => {
    if (localStorage.getItem("userToken") !== null) {
      let orden = {};
      if (parseInt(id) > 0) {
        const resultSubmitPolicy = await dispatch(getPolicyData({ id: id }));
        orden = resultSubmitPolicy.payload.data;
        customerId = orden.client_id;
      }

      if (localStorage.getItem("policyData") !== null) {
        orden = JSON.parse(localStorage.getItem("policyData"));
      }

      const resultSubmit = await dispatch(
        getCustomerByToken({ customerId: customerId })
      );
      let dataPolicy = {};
      dataPolicy["catalogs"] = resultSubmit.payload.data.catalogs;
      if (dataPolicy["catalogs"].vehicle_types) {
        let vehicle = dataPolicy["catalogs"].vehicle_types.find(
          (item) => item.id === "1"
        );
        vehicle &&
          (vehicle.icon = <VehicleIcon className={classes.optionInput} />);

        vehicle = dataPolicy["catalogs"].vehicle_types.find(
          (item) => item.id === "4"
        );
        vehicle &&
          (vehicle.icon = <MotorhomeIcon className={classes.optionInput} />);

        vehicle = dataPolicy["catalogs"].vehicle_types.find(
          (item) => item.id === "5"
        );
        vehicle &&
          (vehicle.icon = <MotorcycleIcon className={classes.optionInput} />);

        vehicle = dataPolicy["catalogs"].vehicle_types.find(
          (item) => item.id === "11"
        );
        vehicle && (vehicle.icon = <ATVIcon className={classes.optionInput} />);
        //vehicle = dataPolicy["catalogs"].vehicle_types.find(item => item.id === "10");
        //vehicle && (vehicle.icon = <TruckIcon className={classes.optionInput} />);
        dataPolicy["catalogs"].vehicle_types.splice(6, 1);
        dataPolicy["catalogs"].vehicle_types.splice(4, 1);
        dataPolicy["catalogs"].vehicle_types.splice(3, 1);
      }
      if (dataPolicy["catalogs"].agencies) {
        /*dataPolicy["catalogs"].agencies.push({
          id: 19,
          city: "",
          agency_name: "Sanborn’s Online",
        });
        */
      }
      resultSubmit.payload.data.catalogs = dataPolicy["catalogs"];
      getClientCards(resultSubmit.payload.data?.data_customer?.id);
      if (
        typeof id == "undefined" &&
        localStorage.getItem("policyData") === null
      ) {
        setClientData(resultSubmit.payload.data);
      } else {
        getData(resultSubmit.payload.data, orden);
      }
      getVehicles(resultSubmit.payload.data?.data_customer?.id);
    }
  };

  const validDays = (numDays) => {
    if (numDays > 30 && ![30, 90, 182, 365].includes(numDays)) {
      numDays = 30;
    }
    return numDays;
  };

  const getData = (datosIniciales, orden) => {
    let selectedVehicle = {
      model_vehicle: "",
      make_vehicle: "",
      type_name: "",
      vehicle_type: "",
      id: "",
      lienholder: "",
      insurance_company: "",
      insurance_policy_number: "",
      mileage: "",
      plates: "",
      sp_equip_list: null,
      sp_equip_value: null,
      total_value: "",
      trailer: "",
      vin: "",
      year_model: "",
      client_id: "",
      model: " ",
      vehicle_type_id: "",
      sentri_number: "",
      other: "",
      year_model_trailer: "",
      model_trailer: "",
      vin_trailer: "",
      total_value_trailer: "",
      plates_trailer: "",
      lienholder_trailer: null,
      sp_equip_list_trailer: null,
      sp_equip_value_trailer: null,
      year_model_other: "",
      model_other: "",
      vin_other: "",
      total_value_other: "",
      plates_other: "",
      lienholder_other: null,
      sp_equip_list_other: null,
      sp_equip_value_other: null,
      make_trailer: "",
      make_other: "",
      make: "",
      lienholder_vehicle_address: "",
      lienholder_trailer_address: null,
      lienholder_other_address: null,
      vehtype_trailer: "",
      vehtype_other: "",
      description_trailer: "",
      description_other: "",
      other_policy_company_trailer: "",
      other_policy_number_trailer: "",
      other_policy_company_other: "",
      other_policy_number_other: "",
      commercial: "",
      active: "",
      client_have_lienholder: "",
      vehicle_type_model: "",
      makeId: "",
      name: "",
      modelId: "",
    };

    if (orden) {
      if (localStorage.getItem("policyData") !== null) {
        datosIniciales.selectedVehicle = orden.selectedVehicle;
        orden.coverages.timezone = timeZoneList[orden.coverages.borderCrossing];
        datosIniciales.coverages = orden.coverages;
        datosIniciales.data_customer.addressG =
          datosIniciales.data_customer.address;
        setPersonData(datosIniciales.data_customer);
        setCoverages(orden.coverages);
        setVehicleData(orden.selectedVehicle);
        setData(datosIniciales);
        localStorage.removeItem("policyData");
      } else {
        for (const key in datosIniciales.data_customer) {
          if (
            key !== "id" &&
            key !== "agency_id" &&
            key !== "agent_id" &&
            key !== "email" &&
            key !== "dl_number" &&
            key !== "preferred_language"
          ) {
            datosIniciales.data_customer[key] = orden[key];
          }
        }

        for (const key in selectedVehicle) {
          if (key !== "id") {
            selectedVehicle[key] = orden[key];
          }
        }

        if ([1, 5].includes(parseInt(orden["vehicle_type_id"]))) {
          selectedVehicle["makeId"] = orden["make"];
          selectedVehicle["modelId"] = orden["model"];
        }

        let currentCoverages = { ...coverages };

        for (const key in coverages) {
          if (!["id", "expirationdate", "effectivedate"].includes(key)) {
            currentCoverages[key] = orden[key];
          }
        }

        datosIniciales.data_customer.addressG =
          datosIniciales.data_customer.address;

        currentCoverages["timezone"] =
          timeZoneList[currentCoverages["bordercross"]];
        currentCoverages["damageded_customer"] = orden["damageded"];
        currentCoverages["theftded_customer"] = orden["theftded"];
        currentCoverages["policynotes"] = orden["notes"];
        coverages["csllimit"] = cslLimitCheck(orden["csllimit"]);

        if (orden.order_status_id == "3") {
          datosIniciales.orderData = {};
          datosIniciales.orderData.quote_id = orden.order_id;
          datosIniciales.orderData.vehicle_id = orden.vehicle_id;
          datosIniciales.orderData.vehicle_order_id = orden.vehicle_order_id;
          datosIniciales.orderData.client_id = orden.client_id;
          datosIniciales.orderData.client_order_id = orden.client_order_id;
          currentCoverages["timeset"] = orden.effective_time;
          currentCoverages["days"] = validDays(orden.num_of_days);
          currentCoverages["policy_type"] = orden.policy_type;
          if (orden.expiration_date != null) {
            currentCoverages[
              "expirationdate"
            ] = formatDateToEffectiveAndExpiration(
              orden.expiration_date,
              "quote"
            ).date;
          }
          const effectiveTime = orden.effective_time || null;
          if (effectiveTime !== null) {
            let timesetData = orden.effective_time.split(" ");
            currentCoverages["startTime"] = timesetData[0];
            currentCoverages["meridian"] = timesetData[1];
            currentCoverages["timeset"] = timesetData[0];
          }
        }

        if (orden.effective_date != null) {
          const startData = formatDateToEffectiveAndExpiration(
            orden.effective_date,
            "quote"
          );
          currentCoverages["effectivedate"] = startData.date;
          currentCoverages["startDate"] = startData.dateComponent;
          setCurrentStartDate(startData.dateComponent);
        }

        currentCoverages.physical_damage =
          currentCoverages.physical_damage == "1" ? "true" : "false";
        currentCoverages.roadside =
          currentCoverages.roadside == "1" ? "true" : "false";
        currentCoverages.gapcoverage =
          currentCoverages.gapcoverage == "1" ? "yes" : "no";
        currentCoverages.fixeddeductible =
          currentCoverages.fixeddeductible == "1" ? "true" : "false";
        currentCoverages.theft =
          currentCoverages.theft == "1" ? "true" : "false";
        currentCoverages.legalaid =
          currentCoverages.legalaid == "1" ? "true" : "false";
        currentCoverages.premierepackage =
          currentCoverages.premierepackage == "0" ||
          currentCoverages.csllimit == "50000"
            ? "false"
            : "true";
        datosIniciales.selectedVehicle = selectedVehicle;
        datosIniciales.coverages = currentCoverages;
        datosIniciales.coverages.specialdiscount = orden.special_discount;
        datosIniciales.coverages.policynumber = orden.policy_nbr;
        datosIniciales.coverages.days = validDays(orden.num_of_days);
        const timesetData = orden.effective_time.split(" ");
        datosIniciales.coverages.timeset = timesetData[0];
        datosIniciales.coverages.meridian = timesetData[1];
        datosIniciales.coverages.quote_id = orden.order_id;
        datosIniciales.coverages.vehicle_id = orden.vehicle_id;
        datosIniciales.coverages.client_id = orden.client_id;
        datosIniciales.coverages.vehicle_order_id = orden.vehicle_order_id;
        datosIniciales.coverages.client_order_id = orden.client_order_id;
        datosIniciales.coverages.date_cancellation =
          currentDateEndorsement + " " + currentTimeEndorsement;
        datosIniciales.coverages.cancellationtype = "";
        datosIniciales.coverages.from_date = "";
        datosIniciales.coverages.csrinitials = "";
        datosIniciales.coverages.policy_fee = orden.policy_fee;
        datosIniciales.coverages.agency_fee = orden.agency_fee;
        datosIniciales.coverages.iva = orden.iva;
        datosIniciales.coverages.premium = orden.premium;
        datosIniciales.coverages.retainpolicyfee = "No";
        datosIniciales.coverages.retainagencyfee = "No";
        datosIniciales.coverages.aux_from_date =
          orden.effective_date + " " + orden.effective_time;
        setCoverages(datosIniciales.coverages);
        datosIniciales.data_customer.preferred_language =
          localStorage.getItem("userType") != 3
            ? datosIniciales.data_customer.preferred_language
            : i18n.language;
        setPersonData(datosIniciales.data_customer);
        datosIniciales.selectedVehicle.days = validDays(
          parseInt(orden.num_of_days)
        );
        datosIniciales.selectedVehicle.borderCrossing = coverages.bordercross;
        datosIniciales.selectedVehicle.vehtype =
          selectedVehicle.vehicle_type_id;
        datosIniciales.selectedVehicle.total_value_vehicle =
          selectedVehicle.total_value;
        datosIniciales.selectedVehicle.agent =
          datosIniciales.data_customer.agent_id;
        datosIniciales.selectedVehicle.licensePlate = selectedVehicle.plates;
        datosIniciales.selectedVehicle.insuranceCompany =
          selectedVehicle.insurance_company;
        datosIniciales.selectedVehicle.fullCoverage = selectedVehicle.insurance_policy_number.toLowerCase();
        datosIniciales.selectedVehicle.vehicleType = selectedVehicle.type_name;
        datosIniciales.selectedVehicle.vehicleTypeId =
          selectedVehicle.vehicle_type_id;
        datosIniciales.selectedVehicle.vehicleYear = selectedVehicle.year_model;
        datosIniciales.selectedVehicle.vehicleMakeId = selectedVehicle.makeId;
        datosIniciales.selectedVehicle.vehicleMakeName =
          selectedVehicle.make_vehicle;
        datosIniciales.selectedVehicle.vehicleModelId = selectedVehicle.modelId;
        datosIniciales.selectedVehicle.vehicleModelName = selectedVehicle.model;
        datosIniciales.selectedVehicle.makeVehicle = selectedVehicle.makeId;
        datosIniciales.selectedVehicle.vehicleModel = selectedVehicle.modelId;
        datosIniciales.selectedVehicle.vehicleMake = selectedVehicle.makeId;
        datosIniciales.selectedVehicle.total_value_trailer =
          selectedVehicle.trailer == "0"
            ? -1
            : selectedVehicle.total_value_trailer;
        datosIniciales.selectedVehicle.towed_total_value_vehicle =
          datosIniciales.selectedVehicle.total_value_trailer;
        datosIniciales.selectedVehicle.towed_vin =
          datosIniciales.selectedVehicle.vin_trailer;
        datosIniciales.selectedVehicle.towed_vehicleYear =
          selectedVehicle.year_model_trailer;
        datosIniciales.selectedVehicle.towed_make =
          selectedVehicle.make_trailer;
        datosIniciales.selectedVehicle.towed_model =
          selectedVehicle.model_trailer;
        datosIniciales.selectedVehicle.secondary_total_value_vehicle =
          datosIniciales.selectedVehicle.total_value_trailer;
        datosIniciales.selectedVehicle.secondary_vin =
          datosIniciales.selectedVehicle.vin_other;
        datosIniciales.selectedVehicle.secondary_vehicleYear =
          selectedVehicle.year_model_other;
        datosIniciales.selectedVehicle.secondary_make =
          selectedVehicle.make_other;
        datosIniciales.selectedVehicle.secondary_model =
          selectedVehicle.model_other;
        datosIniciales.selectedVehicle.towingUnits =
          selectedVehicle.trailer == "1" ? "yes" : "no";
        setVehicleData(datosIniciales.selectedVehicle);
        setData(datosIniciales);
      }
      let tempSteps = { ...steps };
      tempSteps = updateStep1(
        datosIniciales.selectedVehicle,
        datosIniciales.coverages,
        tempSteps
      );
      tempSteps = updateStep2(datosIniciales.data_customer, tempSteps);
      tempSteps = updateStep3(datosIniciales.selectedVehicle, tempSteps);
      setSteps(tempSteps);
    }
  };

  const cslLimitCheck = (value) => {
    let newValueCsl = value || "";
    newValueCsl = ["100000", "200000", "300000"].includes(newValueCsl)
      ? ""
      : newValueCsl;
    return newValueCsl;
  };

  const setClientData = (apiCustomerData) => {
    let currentVehicleData = { ...vehicleData };
    if (typeof apiCustomerData.data_customer != "undefined") {
      apiCustomerData.coverages = coverages;
      apiCustomerData.data_customer.addressG =
        apiCustomerData.data_customer.address;
      currentVehicleData.agent = apiCustomerData.data_customer.agency_id;
      setPersonData(apiCustomerData.data_customer);
      setVehicleData(currentVehicleData);
      if (isAgent) {
        let currentData = { ...data };
        apiCustomerData.catalogs.special_discounts =
          currentData.catalogs.special_discounts;
      }
      setData(apiCustomerData);
    }
  };

  const getClientCards = async (clientId) => {
    setClientCards([]);
    setCard(cardDataInitial);
    const resultSubmit = await dispatch(
      getCardsByClient({ clientId: clientId })
    );

    if (resultSubmit.payload.result) {
      if (resultSubmit.payload.result) {
        if (resultSubmit.payload.data.length > 0) {
          setClientCards(resultSubmit.payload.data);
        } else {
          setClientCards([]);
        }
      }
    } else {
      let mensaje = "\n";
      for (const key in resultSubmit.payload.message) {
        mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
      }
    }
    setDeleteCardModal(false);
  };

  const closeDialogError = () => {
    setOpenModalError(false);
  };

  const handlerDeleteCard = async (cardId) => {
    const resultSubmit = await dispatch(deleteCard({ id: cardId }));
    setAlert(null);
    if (resultSubmit.payload.result) {
      if (resultSubmit.payload.result) {
        setCreditCardListModal(false);
        setSelectedValue(null);
        setCard(cardDataInitial);
        getClientCards(data.data_customer?.id);
      }
    } else {
      let mensaje = "\n";
      for (const key in resultSubmit.payload.message) {
        mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
      }
    }
  };

  const saveQuote = async (dataSend, resultRates) => {
    if (
      dataSend.coverages.cancellationtype != "" &&
      dataSend.coverages.from_date != "" &&
      dataSend.coverages.csrinitials != ""
    ) {
      setToastMessage(false);
      let dataCancellation = setDataCancellation(dataSend, resultRates);
      loadingAlert();
      const resultSubmit = await dispatch(saveCancellation(dataCancellation));
      setAlertLoading(null);
      if (resultSubmit.payload) {
        if (resultSubmit.payload.result) {
          setOrderDataSuccess(resultSubmit.payload);
          setModalSuccess(true);
        } else {
          if (resultSubmit.payload.message.errors) {
            let messageToast = "<ul>";
            resultSubmit.payload.message.errors.map(
              (error, index) =>
                (messageToast += `<li key=${index}>${error.Message}</li>`)
            );
            messageToast += `</ul>`;
            setMessageToast(messageToast);
            setOpenModalError(true);
          }
        }
      } else {
        let mensaje = "\n";
        for (const key in resultSubmit.payload.message) {
          mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
        }
      }
    } else {
      setTypeToast("danger");
      let errorMessageIssue =
        "Please check the information in the cancellation";
      setMessageToast(errorMessageIssue);
      setToastMessage(true);
    }
  };

  const printQuote = async (dataSend) => {
    if (dataSend.selectedVehicle != null) {
      setToastMessage(false);
      dataSend.flag_draft = 1;
      let dataPolicy = setDataPolicy(dataSend);
      loadingAlert();
      const resultSubmit = await dispatch(print(dataPolicy));
      setAlertLoading(null);
      if (resultSubmit.payload) {
        let a = document.createElement("a");
        a.href =
          "data:application/pdf;base64," + resultSubmit.payload.data.file;
        a.download = `${resultSubmit.payload.data.name}.pdf`;
        a.click();
      } else {
        let mensaje = "\n";
        for (const key in resultSubmit.payload.message) {
          mensaje += "\u2B24" + " " + resultSubmit.payload.message[key] + "\n";
        }
      }
    } else {
      setTypeToast("danger");
      let errorMessageIssue = "Please select a vehicle valid";
      setMessageToast(errorMessageIssue);
      setToastMessage(true);
    }
  };

  const updateStep = (step, savePolicy) => {
    switch (step) {
      case 0:
        childRefStep1.current.saveStepComplete(savePolicy);
        break;
      case 1:
        childRefStep2.current.saveStepComplete(savePolicy);
        break;
      case 2:
        childRefStep3.current.saveStepComplete(savePolicy);
        break;
      case 3:
        childRefStep4.current.saveStepComplete(savePolicy);
        break;
    }
    setActiveStep(step);
  };

  const getVehicles = async (customerId) => {
    const resultSubmit = await dispatch(
      getVehiclesList({ customerId: customerId })
    );
    if (resultSubmit.payload.result) {
      setVehicles(resultSubmit.payload.data);
    }
  };

  const setStepData = (type, dataStep) => {
    let dataGuest = { ...data };
    let insertStep = true;
    if (type == "fastquote") {
      setFastQuote(dataStep);
      insertStep = false;
    }
    if (type == "fullQuoteVehicle") {
      setFullQuoteVehicle(dataStep);
      insertStep = false;
    }
    if (type == "fullQuoteRates") {
      setFullQuoteRates(dataStep);
      insertStep = false;
    }
    if (type == "addVehicle") {
      setAddVehicle(dataStep);
      insertStep = false;
    }
    if (type == "vehicleDataFromSite") {
      setVehicleDataFromSite(dataStep);
      insertStep = false;
    }
    if (type == "showAddVehicle") {
      setShowAddVehicle(dataStep);
      insertStep = false;
    }
    if (type == "delete selectedVehicle") {
      let dataPolicy = { ...data };
      delete dataPolicy["selectedVehicle"];
      setData(dataPolicy);
      insertStep = false;
    }

    if (type == "calculateRates") {
      setCalculateRates(dataStep);
      insertStep = false;
    }
    if (type == "coveragesRates") {
      dataGuest.coverages.premium = dataStep.premium;
      dataGuest.coverages.policy_fee = dataStep.policy_fee;
      dataGuest.coverages.iva = dataStep.iva;
      dataGuest.coverages.total = dataStep.total;
      dataGuest.coverages.additional_charges = dataStep.additional_charges;
      dataGuest.coverages.pd_ded = dataStep.pd_ded;
      dataGuest.coverages.theft_ded = dataStep.theft_ded;
    }
    if (insertStep) {
      dataGuest[type] = dataStep;
      setData(dataGuest);
    }
  };

  const setPaymentTypeData = (paymentTypeId) => {
    setMessageToast("");
    setPaymentType(paymentTypeId);
  };

  const [steps, setSteps] = React.useState([
    { title: t("steps.quote") },
    {
      title: t("steps.insuredInformation"),
    },
    {
      title: t("steps.vehicleInformation"),
    },
    { title: t("steps.coverageAndPayment") },
  ]);

  const daysOptions = [
    { value: 1, label: t("daysOptions.1day") },
    { value: 2, label: t("daysOptions.2days") },
    { value: 3, label: t("daysOptions.3days") },
    { value: 4, label: t("daysOptions.4days") },
    { value: 5, label: t("daysOptions.5days") },
    { value: 6, label: t("daysOptions.6days") },
    { value: 7, label: t("daysOptions.7days") },
    { value: 8, label: t("daysOptions.8days") },
    { value: 9, label: t("daysOptions.9days") },
    { value: 10, label: t("daysOptions.10days") },
    { value: 11, label: t("daysOptions.11days") },
    { value: 12, label: t("daysOptions.12days") },
    { value: 13, label: t("daysOptions.13days") },
    { value: 14, label: t("daysOptions.14days") },
    { value: 15, label: t("daysOptions.15days") },
    { value: 16, label: t("daysOptions.16days") },
    { value: 17, label: t("daysOptions.17days") },
    { value: 18, label: t("daysOptions.18days") },
    { value: 19, label: t("daysOptions.19days") },
    { value: 20, label: t("daysOptions.20days") },
    { value: 21, label: t("daysOptions.21days") },
    { value: 22, label: t("daysOptions.22days") },
    { value: 23, label: t("daysOptions.23days") },
    { value: 24, label: t("daysOptions.24days") },
    { value: 25, label: t("daysOptions.25days") },
    { value: 26, label: t("daysOptions.26days") },
    { value: 27, label: t("daysOptions.27days") },
    { value: 28, label: t("daysOptions.28days") },
    { value: 29, label: t("daysOptions.29days") },
    { value: 30, label: t("daysOptions.30days") },
    { value: 90, label: t("daysOptions.90days") },
    { value: 182, label: t("daysOptions.6months") },
    { value: 365, label: t("daysOptions.1year") },
  ];

  const getFormattedDate = (days = 0, dateInitial = null) => {
    let utcDate = new Date();
    if (dateInitial) {
      const baseDate = new Date(dateInitial);
      utcDate = new Date(
        Date.UTC(
          baseDate.getUTCFullYear(),
          baseDate.getUTCMonth(),
          baseDate.getUTCDate()
        )
      );
    }
    utcDate.setUTCDate(utcDate.getUTCDate() + parseInt(days));
    const month = String(utcDate.getUTCMonth() + 1).padStart(2, "0");
    const day = String(utcDate.getUTCDate()).padStart(2, "0");
    const year = utcDate.getUTCFullYear();
    return `${month}-${day}-${year}`;
  };

  const previewStep2 = () => {
    setActiveStep(0);
  };
  const previewStep3 = () => {
    setActiveStep(1);
  };
  const previewStep4 = () => {
    setActiveStep(2);
  };
  const completeStep1 = (vehicleData, coverages) => {
    const updatedSteps = updateStep1(vehicleData, coverages, { ...steps });
    setSteps(updatedSteps);
    setVehicleData(vehicleData);
    setCoverages(coverages);
  };

  const updateStep1 = (vehicleData, coverages, tempSteps) => {
    const updatedSteps = Object.entries(tempSteps).map(([, step], index) => {
      if (index === 0) {
        const option = daysOptions.find((e) => e.value === vehicleData.days);
        const formattedLabel = option
          ? option.label
              .split(" ")
              .map((part, idx) =>
                idx === 0 ? (
                  <span style={{ fontWeight: "bold", color: "#000" }}>
                    {part}
                  </span>
                ) : (
                  ` ${part}`
                )
              )
          : null;

        return {
          ...step,
          descriptions: (
            <div
              style={{
                marginLeft: "10px",
                color: "#6B7280",
                paddingLeft: "1em",
              }}
              className={"descriptionContent"}
            >
              <WhiteCalendarIcon /> {formattedLabel}
              <br />
              <WhiteCheckIcon /> Starting:{" "}
              <span style={{ fontWeight: "bold", color: "#000" }}>
                {getFormattedDate(0, coverages.startDate)}
              </span>
              <br />
              <WhiteCheckIcon /> Ending:{" "}
              <span style={{ fontWeight: "bold", color: "#000" }}>
                {getFormattedDate(vehicleData.days, coverages.startDate)}
              </span>
            </div>
          ),
        };
      }
      return step;
    });
    return updatedSteps;
  };

  const submitStep2 = (personData, vehicleData, accountCheck, save) => {
    setPersonData(personData);
    setVehicleData(vehicleData);
    setStepData("data_customer", personData);
    setCheckedAccount(accountCheck);
    let cardData = { ...card };
    cardData["fname-card"] = personData.first_name;
    cardData["lname-card"] = personData.last_name;
    setCard(cardData);
    const updatedSteps = updateStep2(personData, steps);
    setActiveStep(2);
    setSteps(updatedSteps);
    if (save) {
      let policyData = { ...data };
      policyData.selectedVehicle = vehicleData;
      policyData.data_customer = personData;
      saveQuote(policyData);
    }
  };
  const updateStep2 = (personData, tempSteps) => {
    tempSteps[1].descriptions = (
      <div
        style={{
          marginLeft: "10px",
          color: "#6B7280",
          paddingLeft: "1em",
        }}
        className={"descriptionContent"}
      >
        <WhiteCheckIcon></WhiteCheckIcon>
        <span style={{ fontWeight: "bold", color: "#000" }}>
          {` ${personData.first_name} ${personData.last_name}`}
        </span>
        <br />
        <WhiteCheckIcon></WhiteCheckIcon>
        <span style={{ fontWeight: "bold", color: "#000" }}>
          {` ${personData.email}`}
        </span>
      </div>
    );
    return tempSteps;
  };
  const checkValueVehicle = (vehicleData, coveragesData) => {
    if (vehicleData.total_value_vehicle == "0") {
      coveragesData.physical_damage = false;
      coveragesData.theft = false;
      coveragesData.premierepackage = false;
    } else {
      coveragesData.physical_damage = true;
      coveragesData.theft = true;
      coveragesData.premierepackage =
        coveragesData.csllimit == "50000" ? false : true;
    }
    return coveragesData;
  };
  const submitStep3 = (vehicleData, save) => {
    setVehicleData(vehicleData);
    setStepData("selectedVehicle", vehicleData);
    setActiveStep(3);
    let coveragesData = { ...coverages };
    coveragesData = checkValueVehicle(vehicleData, coveragesData);
    coveragesData.roadside =
      vehicleData.vehicle_type_id == "11" ||
      vehicleData.vehicle_type_id == "7" ||
      coveragesData.roadside == false
        ? false
        : true;
    setCoverages(coveragesData);
    const updatedSteps = updateStep3(vehicleData, steps);
    setSteps(updatedSteps);
    setActiveStep(3);
    if (save) {
      let policyData = { ...data };
      policyData.selectedVehicle = vehicleData;
      policyData.coverages = coveragesData;
      saveQuote(policyData);
    }
  };
  const updateStep3 = (vehicleData, tempSteps) => {
    let option = null;
    let vehDataName = vehicleData.vehText;
    if (data !== null) {
      option = data["catalogs"].vehicle_types.find(
        (e) => e.id === vehicleData.vehicle_type_id + ""
      );
    } else {
      option = { name: vehicleData.type_name };
      vehDataName =
        vehicleData.year_model +
        " " +
        vehicleData.make_vehicle +
        " " +
        vehicleData.model_vehicle;
    }
    tempSteps[2].descriptions = (
      <div
        style={{
          marginLeft: "10px",
          color: "#6B7280",
          paddingLeft: "1em",
        }}
        className={"descriptionContent"}
      >
        <WhiteCarIcon></WhiteCarIcon>
        <span style={{ fontWeight: "bold", color: "#000" }}>
          {` ${option ? option.name : ""}`}
        </span>
        <br />
        <WhiteCheckIcon></WhiteCheckIcon>
        <span style={{ fontWeight: "bold", color: "#000" }}>
          {` ${vehDataName}`}
        </span>
        <br />
        <WhiteCheckIcon></WhiteCheckIcon>
        <span style={{ fontWeight: "bold", color: "#000" }}>
          {vehicleData.total_value_vehicle
            ? ` $${formatNumber(vehicleData.total_value_vehicle)}`
            : " Liability only"}
        </span>
      </div>
    );
    return tempSteps;
  };
  const submitStep4 = (coverages, resultRates, save) => {
    setResultRates(resultRates);
    setCoverages(coverages);
    let policyData = { ...data };
    policyData.coverages = coverages;
    policyData.coverages.premium = resultRates.premium;
    policyData.coverages.policy_fee = resultRates.policy_fee;
    policyData.coverages.iva = resultRates.iva;
    policyData.coverages.total = resultRates.total;
    policyData.coverages.additional_charges = resultRates.additional_charges;
    policyData.coverages.pd_ded = resultRates.pd_ded;
    policyData.coverages.theft_ded = resultRates.theft_ded;
    policyData.resultRates = resultRates;
    setData(policyData);
    const updatedSteps = updateStep4(vehicleData, steps);
    setSteps(updatedSteps);
    if (save) {
      saveQuote(policyData);
    }
  };

  const updateStep4 = (vehicleData, tempSteps) => {
    let option = null;
    if (data !== null) {
      option = data["catalogs"].vehicle_types.find(
        (e) => e.id === vehicleData.vehicle_type_id + ""
      );
    }
    tempSteps[2].descriptions = (
      <div
        style={{
          marginLeft: "10px",
          color: "#6B7280",
          paddingLeft: "1em",
        }}
        className={"descriptionContent"}
      >
        <WhiteCarIcon></WhiteCarIcon>
        <span style={{ fontWeight: "bold", color: "#000" }}>
          {` ${option ? option.name : ""}`}
        </span>
        <br />
        <WhiteCheckIcon></WhiteCheckIcon>
        <span style={{ fontWeight: "bold", color: "#000" }}>
          {` ${vehicleData.vehText}`}
        </span>
        <br />
        <WhiteCheckIcon></WhiteCheckIcon>
        <span style={{ fontWeight: "bold", color: "#000" }}>
          {` $${formatNumber(vehicleData.total_value_vehicle)}`}
        </span>
      </div>
    );
    return tempSteps;
  };

  const [activeStep, setActiveStep] = React.useState(0);
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, [activeStep]);

  const googleMapsKey = process.env.REACT_APP_GOOGLE_MAPS_KEY;
  return (
    <div className={classes.container}>
      {alert}
      {alertLoading}
      <LoadScript
        googleMapsApiKey={googleMapsKey}
        libraries={["places"]}
        language="en"
      >
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={12}>
            <GridContainer
              style={{ padding: "40px 0px 40px 0px" }}
              justify="center"
            >
              <GridItem xs={12} md={3}>
                <StepperComponent
                  steps={steps}
                  activeStep={activeStep}
                  updateStep={updateStep}
                  orientation={isXs || isSm ? "horizontal" : "vertical"}
                />
                <GridItem xs={12} sm={12} md={10} lg={10}>
                  <Button
                    id="loginMobile"
                    variant="green"
                    onClick={() => updateStep(activeStep, true)}
                    style={{
                      width: "100%",
                      marginTop: "25px",
                      display:
                        personData.first_name != "" &&
                        vehicleData.vin != "" &&
                        coverages.endorsementtype != ""
                          ? "block"
                          : "none",
                    }}
                  >
                    {t("saveQuote")}
                  </Button>
                </GridItem>
                <GridItem xs={12} sm={12} md={10} lg={10}>
                  <Button
                    id="loginMobileBack"
                    variant="white"
                    onClick={() =>
                      (window.location.href = "/guest/summary/" + id)
                    }
                    style={{
                      width: "100%",
                      marginTop: "25px",
                    }}
                  >
                    {t("Back")}
                  </Button>
                </GridItem>
              </GridItem>
              <GridItem xs={12} md={9}>
                {data && data.catalogs && (
                  <>
                    <div
                      style={{
                        display: activeStep === 0 ? "block" : "none",
                      }}
                    >
                      <Step1
                        data={data}
                        producerCode={producerCode}
                        setAlertAgency={setAlertAgency}
                        vehicleData={vehicleData}
                        agencyData={agencyData}
                        coverages={coverages}
                        handleSubmitStep={saveQuote}
                        ref={childRefStep1}
                        isSmall={isXs || isSm ? true : false}
                        isLogged={isLogged}
                      />
                    </div>
                  </>
                )}
              </GridItem>
            </GridContainer>
          </GridItem>
          <Dialog
            style={{ zIndex: "3000" }}
            open={openModalError}
            onClose={closeDialogError}
            classes={{
              root: classesDialogs.center + " " + classesDialogs.modalRoot,
              paper: classesDialogs.modal,
            }}
            keepMounted
            TransitionComponent={Transition}
          >
            <DialogTitle
              disableTypography
              className={classesDialogs.modalHeaderError}
              style={{ color: "#e8403c" }}
            >
              <Button
                justIcon
                className={classesDialogs.modalCloseButton}
                key="close"
                aria-label="Close"
                color="transparent"
                onClick={closeDialogError}
              >
                <Close
                  className={classesDialogs.modalClose}
                  style={{ color: "white" }}
                />
              </Button>
              <h4
                className={classesDialogs.modalTitle}
                style={{ color: "white" }}
              >
                Attention
              </h4>
            </DialogTitle>
            <DialogContent style={{ textAlign: "left" }}>
              <div
                dangerouslySetInnerHTML={{
                  __html: sanatizeMessageHtml(messageToast),
                }}
              ></div>
            </DialogContent>
          </Dialog>

          <PaymentType
            isOpen={paymentModal}
            onClose={closeModal}
            inputHandler={inputHandler}
            callBackCard={callBackCard}
            cardData={card}
            handlerSaveCard={handlerSaveCard}
            handlerCardData={handlerCardData}
            saveCard={saveCard}
            paymentType={paymentType}
            setPaymentType={setPaymentTypeData}
            paymentTypeList={paymentTypeList}
            messageToast={messageToast}
            policyDataLogin={policyDataLogin}
            clientCards={clientCards}
            handleChangeRadio={handleChangeRadio}
            inputHandlerCcv={inputHandlerCcv}
            selectedValue={selectedValue}
            creditCardListModal={creditCardListModal}
            closeCardListModal={toggleCardListModal}
            verifyPaymentType={verifyPaymentType}
            savingCard={savingCard}
            cancelSaveCard={cancelSaveCard}
            data={data}
            loadingCircle={loadingCircle}
            isLogged={isLogged}
            setModalTerms={setModalTerms}
            showTerms={isAgent ? false : true}
            disabledPayButton={disabledPayButton}
          ></PaymentType>

          <CreditCardList
            selectedValue={selectedValue}
            creditCardListModal={creditCardListModal}
            onClose={toggleCardListModal}
            handleChangeRadio={handleChangeRadio}
            inputHandler={inputHandlerCcv}
            handlerCardData={handlerCardData}
            handlerDeleteCard={showAlertCard}
            clientCards={clientCards}
          ></CreditCardList>

          <DeleteCreditCard
            deleteCardModal={deleteCardModal}
            handlerDeleteCard={handlerDeleteCard}
            closeModal={toggleDeleteCardModal}
            idCard={idCardToDelete}
          ></DeleteCreditCard>

          <CustomModal
            title="Attention"
            isOpen={isOpenErrors}
            onClose={setIsOpenErrors}
            privacy={false}
            id={isLogged ? "errorModal" : "errorModalGuest"}
          >
            <GridContainer>
              <GridItem xs={12}>
                <p style={{ color: "red" }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: sanatizeMessageHtml(messageToast),
                    }}
                  ></div>
                </p>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={1}></GridItem>
              <GridItem xs={checkLoginButton() && showContinueGuest ? 5 : 10}>
                {checkLoginButton() && (
                  <Button
                    id="loginMobile"
                    type="submit"
                    onClick={() => sendToLogin()}
                    variant="red"
                    block
                  >
                    Login
                  </Button>
                )}
              </GridItem>
              <GridItem xs={checkLoginButton() && showContinueGuest ? 5 : 10}>
                {showContinueGuest && (
                  <CustomButton
                    id="continueGuest"
                    type="submit"
                    variant="green"
                    onClick={() => {
                      setIsOpenErrors(false);
                      setMessageToast("");
                      setPaymentModal(true);
                      setActiveStep(3);
                    }}
                    block
                  >
                    Continue as Guest
                  </CustomButton>
                )}
              </GridItem>
            </GridContainer>
          </CustomModal>
          <CustomModal
            title=""
            isOpen={modalSuccess}
            onClose={() => successPolicy()}
            privacy={false}
            id={isLogged ? "successModal" : "successModalGuest"}
          >
            <GridContainer>
              <GridContainer>
                <GridItem xs={12}>
                  <div class="sa">
                    <div class="sa-success">
                      <div class="sa-success-tip"></div>
                      <div class="sa-success-long"></div>
                      <div class="sa-success-placeholder"></div>
                      <div class="sa-success-fix"></div>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
              <GridItem xs={12}>
                <p style={{ fontSize: "20px" }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: sanatizeMessageHtml(orderDataSuccess.message),
                    }}
                  ></div>
                </p>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12}>
                <CustomButton
                  id="continueGuest"
                  type="submit"
                  variant="green"
                  onClick={() => {
                    successPolicy();
                  }}
                  block
                >
                  Ok
                </CustomButton>
              </GridItem>
            </GridContainer>
          </CustomModal>
          <CustomModal
            title=""
            isOpen={modalTerms}
            onClose={() => setModalTerms(false)}
            privacy={false}
            id={"modalTerms"}
            terms={true}
          >
            <GridContainer>
              <GridItem xs={12}>
                <p style={{ fontSize: "15px" }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: sanatizeMessageHtml(
                        `<div style="text-align: left">
                          <h3 style="text-align: center">
                            Sanborn’s Terms & Conditions of Purchase
                          </h3>
                          <p>
                            I, the Customer identified on the policy, authorize
                            Sanborn’s to charge/transfer electronic funds from
                            the debit or credit card account I specified, or to
                            collect payment through the PayPal account I
                            specified, or through other payment options I may
                            have specified such as Apple Pay, Google Pay,
                            Venmo, etc. for payment(s) of the insurance policy.
                            If the payment is not authorized for any reason, a
                            policy will not be issued and no coverage will be
                            provided.
                          </p>
                          <p>
                            I also acknowledge and agree that Sanborn’s will
                            discontinue acceptance of any subsequent charges I
                            authorized if the charge(s) is invalid or not
                            honored. I am aware that if Sanborn’s is unable to
                            secure funds for the payment(s) I authorized for any
                            reason including, but not limited to, insufficient
                            or uncollected funds or insufficient or inaccurate
                            information I provided, Sanborn’s may undertake
                            further collection action, including application of
                            returned check fees to the extent permitted by law.
                            I understand that such fees may be collected
                            electronically. If the payment is returned by my
                            bank, I am still responsible for paying the amount
                            due to Sanborn’s on or before the effective date of
                            the policy or the policy will be cancelled for
                            non-payment without further notice.
                          </p>
                          Refund policy:
                          <p>
                            I understand I may call 800-222-0158 during business
                            hours, Mon – Fri 8:00 am – 6:00 pm CT, or email
                            service@sanborns.com, or access my Sanborn’s account
                            online at customer.sanborns.com any time prior to
                            the effective date of any policy to request a
                            cancellation and refund of the policy. There are no
                            refunds after the policy has started on policies
                            with a term of less than six months. The insured is
                            required to contact the company before the start
                            date of the policy to request the
                            cancellation/refund. No refunds are processed during
                            holidays or weekends; however, requests received
                            after hours will be honored if received prior to the
                            start date & time. Semi-annual and annual policies
                            are issued at a discounted rate. All policies state
                            "No Refunds, No Cancellations". Semi-annual and
                            annual policies are eligible for a "substitution"
                            should the insured purchase a new vehicle or
                            otherwise need to change the insured vehicle. A
                            prorated credit will be issued for the remainder of
                            the policy to be canceled and applied toward a new
                            semi-annual or annual policy for the new vehicle.
                            The new vehicle must be in the same name as the
                            insured on the policy to be "substituted."
                          </p>
                          Digital Document Delivery
                          <p>
                            I affirmatively consent to the Sanborn’s Insurance
                            Electronic Document Delivery System Disclosure and
                            Consent Agreement, which discloses that Sanborn’s
                            Insurance may deliver any and all documents,
                            applications, policies, notices and agreements
                            generated in the course of my business with
                            Sanborn’s Insurance ("Documents") electronically
                            through the Electronic Document Delivery System
                            including email and/or text. My election to receive
                            Documents electronically will remain in effect
                            until amended or until this Agreement is cancelled
                            or my coverage terminates.
                          </p>
                          Acceptance of Policy Conditions:
                          <p>
                            I understand all insurance policies issued are
                            subject to the conditions of the policy as
                            determined by the insurance company, and hereby,
                            accept these conditions upon purchase of this
                            insurance policy. A copy of the policy conditions
                            are available through the following methods:
                          </p>
                          via email: service@sanborns.com
                          <br />
                          via phone: 800-222-0158
                          <br />
                          Download Online:
                          <a href="www.sanborns.com/hdiconditions">
                            www.sanborns.com/hdiconditions
                          </a>
                          <br />
                          Online by logging into your customer account at:
                          <a href="https://customer.sanborns.com">
                            https://customer.sanborns.com
                          </a>
                        </div>`
                      ),
                    }}
                  ></div>
                </p>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12}>
                <CustomButton
                  id="termsButton"
                  type="submit"
                  variant="green"
                  onClick={() => {
                    setModalTerms(false);
                  }}
                  block
                >
                  Ok
                </CustomButton>
              </GridItem>
            </GridContainer>
          </CustomModal>
          <CustomModal
            title=""
            isOpen={alertAgency}
            onClose={() => setAlertAgency(false)}
            privacy={false}
            id={"agencyModal"}
            terms={true}
          >
            <GridContainer>
              <GridItem xs={12}>
                <p style={{ fontSize: "15px" }}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: sanatizeMessageHtml(
                        `<b>${`Address: `}</b>
                          <br />
                          ${agencyData?.address} ${
                          agencyData?.city
                        } ${`,`}${" "}
                          ${agencyData?.state_name} ${
                          agencyData?.zipcode
                        } <br />
                          <b>${`Phone: `}</b>
                          ${agencyData?.phone}
                          <br />
                          <b>${`Hours of Operation: `}</b>
                          ${agencyData?.hours_opp1} ${agencyData?.hours_opp2}
                          ${agencyData?.hours_opp3}
                          <br />
                          <b>${`Fax: `}</b>
                          ${agencyData?.fax || "none"}
                          <br />
                          <b>${`E-mail: `}</b>
                          ${agencyData?.email}`
                      ),
                    }}
                  ></div>
                </p>
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12}>
                <CustomButton
                  id="agencyModalButton"
                  type="submit"
                  variant="green"
                  onClick={() => {
                    setAlertAgency(false);
                  }}
                  block
                >
                  Ok
                </CustomButton>
              </GridItem>
            </GridContainer>
          </CustomModal>
        </GridContainer>
      </LoadScript>
      <Snackbar
        style={{ zIndex: "3000" }}
        place="br"
        color={typeToast}
        message={messageToast}
        open={toastMessage}
        closeNotification={() => setToastMessage(false)}
        close
      />
    </div>
  );
});

export default WizardView;
